import { defineNuxtPlugin } from '#app/nuxt'
import { LazyBlocks, LazyAccordionItem, LazyAlertBar, LazyArticle, LazyArticleFooter, LazyArticleHeader, LazyBreadcrumbs, LazyCalendarAthleticResults, LazyCalendar, LazyDateFormat, LazyFilters, LazyFormHCaptcha, LazyFormReCaptcha, LazyFormSchema, LazyFormFieldsCheckbox, LazyFormFieldsDatePicker, LazyFormFieldsDropdown, LazyFormFieldsEmail, LazyFormFieldsFileUploader, LazyFormFieldsMultiLine, LazyFormFieldsNumberInput, LazyFormFieldsPhone, LazyFormFieldsRadio, LazyFormFieldsSingleLine, LazyFormFieldsTimePicker, LazyGhostArticle, LazyGoogleTranslate, LazyImage, LazyLightbox, LazyLinkItem, LazyPagination, LazyPlaceholderImage, LazyRichText, LazySearch, LazySkeleton, LazySlider, LazySystemMessage, LazySystemIconsEmptyAsync, LazySystemIconsNoResultsAsync, LazyVideoPlayerVideoModal, LazyVideoPlayer } from '#components'
const lazyGlobalComponents = [
  ["Blocks", LazyBlocks],
["AccordionItem", LazyAccordionItem],
["AlertBar", LazyAlertBar],
["Article", LazyArticle],
["ArticleFooter", LazyArticleFooter],
["ArticleHeader", LazyArticleHeader],
["Breadcrumbs", LazyBreadcrumbs],
["CalendarAthleticResults", LazyCalendarAthleticResults],
["Calendar", LazyCalendar],
["DateFormat", LazyDateFormat],
["Filters", LazyFilters],
["FormHCaptcha", LazyFormHCaptcha],
["FormReCaptcha", LazyFormReCaptcha],
["FormSchema", LazyFormSchema],
["FormFieldsCheckbox", LazyFormFieldsCheckbox],
["FormFieldsDatePicker", LazyFormFieldsDatePicker],
["FormFieldsDropdown", LazyFormFieldsDropdown],
["FormFieldsEmail", LazyFormFieldsEmail],
["FormFieldsFileUploader", LazyFormFieldsFileUploader],
["FormFieldsMultiLine", LazyFormFieldsMultiLine],
["FormFieldsNumberInput", LazyFormFieldsNumberInput],
["FormFieldsPhone", LazyFormFieldsPhone],
["FormFieldsRadio", LazyFormFieldsRadio],
["FormFieldsSingleLine", LazyFormFieldsSingleLine],
["FormFieldsTimePicker", LazyFormFieldsTimePicker],
["GhostArticle", LazyGhostArticle],
["GoogleTranslate", LazyGoogleTranslate],
["Image", LazyImage],
["Lightbox", LazyLightbox],
["LinkItem", LazyLinkItem],
["Pagination", LazyPagination],
["PlaceholderImage", LazyPlaceholderImage],
["RichText", LazyRichText],
["Search", LazySearch],
["Skeleton", LazySkeleton],
["Slider", LazySlider],
["SystemMessage", LazySystemMessage],
["SystemIconsEmptyAsync", LazySystemIconsEmptyAsync],
["SystemIconsNoResultsAsync", LazySystemIconsNoResultsAsync],
["VideoPlayerVideoModal", LazyVideoPlayerVideoModal],
["VideoPlayer", LazyVideoPlayer],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
